// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5482e380]:export{primaryColor:#64b5f6;secondaryColor:#003c60;accentColor:#c41230}.terms_and_conditions_wrapper[data-v-5482e380]{display:flex;justify-content:center;align-items:center;flex-direction:column;grid-gap:20px;gap:20px;margin:12px 12px 80px}.terms-and-conditions[data-v-5482e380]{font-size:13px;font-weight:400;max-width:1240px;line-height:132%;margin:0!important}", ""]);
// Exports
module.exports = exports;
